<div style="margin-left: 39%;" *ngIf="loading">
  <mat-spinner> </mat-spinner>
</div>
<mat-card *ngIf="!loading">
  <div class="maindiv">
      <div class="lf_Rt_holder">
          <div class="lf_Rt">
              <label>Form Type</label>
              <mat-select class="get-select-text" placeholder="Select Form Type" [(ngModel)]="FormcatId">
                  <mat-option *ngFor="let formCat of FormCatList" [value]="formCat.Id" (click)="FormCatSelect()">{{ formCat.Name }} </mat-option>
              </mat-select>
          </div>
          <div class="lf_Rt" *ngIf="showFECRTypes">
              <label>Component Rebuild Form Type</label>
              <mat-select placeholder="Select Component Rebuild Form Type" class="get-select-text" [(ngModel)]="fecrInspectionTypeId">
                  <mat-option *ngFor="let item of FECRInspectionTypes" [value]="item.Id" (click)="SelectFECRInspectionType()">{{ item.Name }} </mat-option>
              </mat-select>
          </div>
      </div>
      <div class="lf_Rt_holder">
          <div class="lf_Rt">
              <label>Form Name</label>
              <input [(ngModel)]="formName" type="text" placeholder="Form Name" (change)="UpdateFormName(1)" required />
          </div>
          <div class="lf_Rt">
              <mat-checkbox class="checkbox-margin pl_5" [(ngModel)]="emailOnclomplete" [disabled]="true" (change)="toggleEmailOnComplete()">
                Email on Complete
            </mat-checkbox>
          </div>
          <div class="lf_Rt">
              <mat-checkbox
                  title="If ticked, this form will always be available and does not require a supervisor to start the form before inspectors can complete it. This would be used for regular day to day forms such as a daily running check sheets"
                  class="checkbox-margin"
                  [(ngModel)]="startbyInspector"
                  (change)="toggleStartByInspector()"
              >
                  Start by Inspector
              </mat-checkbox>
          </div>
          <div class="lf_Rt">
              <mat-checkbox
                  title=""
                  class="checkbox-margin"
                  [(ngModel)]="startbySupervisor"
                  (change)="toggleStartBySupervisor()"
              >
                  Start by Supervisor
              </mat-checkbox>
          </div>
      </div>
      <div class="lf_Rt_holder">
          <div class="lf_Rt">
              <label>Customers to Include</label>
              <mat-select class="get-select-text" placeholder="Select Customers" [(ngModel)]="customerId" multiple>
                  <mat-option *ngFor="let customer of customerList" [value]="customer.CustomerId" (click)="FormCustomersSelect()">{{ customer.CustomerName }} </mat-option>
              </mat-select>
          </div>
      </div>
      <div class="lf_Rt_holder">
          <div class="lf_Rt">
              <label>Jobsites to Include</label>
              <mat-select class="get-select-text" placeholder="Select Jobsite" [(ngModel)]="JobsiteId" multiple>
                  <mat-option *ngFor="let jobsite of jobsiteList" [value]="jobsite.Id" (click)="FormJobsitesSelect()">{{ jobsite.Name }}</mat-option>
              </mat-select>
          </div>
      </div>
      <div style="margin-top: 1%;">
          <mat-checkbox style="margin-right: 9%;" class="checkbox-margin" [(ngModel)]="applytoMachines" [disabled]="true">Apply to equipment</mat-checkbox>
      </div>
      <div style="display: flex; flex-direction: column;">
          <div class="lf_Rt_holder" *ngIf="applytoMachines">
              <div class="lf_Rt">
                  <label>Families to Include</label>
                  <mat-select class="get-select-text" placeholder="Select Families" [(ngModel)]="familyId" multiple>
                      <mat-option *ngFor="let type of familyFilteredList" [value]="type.Id" (click)="loadModelList()">{{ type.Name + " | " + type.Symbol }} </mat-option>
                  </mat-select>
              </div>
          </div>
          <div class="lf_Rt_holder" *ngIf="showModelList && applytoMachines">
              <div class="lf_Rt">
                  <label>Models to Include</label>
                  <mat-select class="get-select-text" placeholder="Select Models" [(ngModel)]="modelId" multiple>
                      <mat-option *ngFor="let item of modelList" [value]="item.Id" (click)="SelectModels()">{{ item.Name }} </mat-option>
                  </mat-select>
              </div>
          </div>
          <div class="lf_Rt_holder" *ngIf="showModelList && applytoMachines">
              <div class="lf_Rt">
                  <label>Implement Link Template</label>
                  <mat-select class="get-select-text" placeholder="Select Implement Template" [(ngModel)]="ImpTemplateId" multiple>
                      <mat-option *ngFor="let item of ImplementTemplateList" [value]="item.Id" (click)="SelectImplement()">{{ item.Name }} </mat-option>
                  </mat-select>
              </div>
          </div>
      </div>
      <div style="display: flex; flex-direction: column; margin-top: 1%;">
          <span class="formheader">Form Header</span>
          <span style="margin-top: 1%; display: none;">
              The form header can include up to 7 fields. The following basic fields are included by default. You may also select to include Question and Answers from the Default Category(first category/section displayed below) by ticking
              the "Include in Header" check box next to the question.
          </span>
          <div style="display: flex; margin-top: 1%;">
              <div style="display: flex; flex-direction: row; width: 10%;">
                  <mat-checkbox class="checkbox-margin" [(ngModel)]="header_Date" (change)="ChangeHeader(3, $event)">Date Started</mat-checkbox>
                  <mat-checkbox class="checkbox-margin" [(ngModel)]="header_Rivision" (change)="ChangeHeader(2, $event)">Form Revision #</mat-checkbox>
                  <mat-checkbox class="checkbox-margin" [(ngModel)]="header_Username" (change)="ChangeHeader(1, $event)">Username</mat-checkbox>
                  <mat-checkbox class="checkbox-margin" [(ngModel)]="header_CusJob" (change)="ChangeHeader(4, $event)">Customer/Jobsite</mat-checkbox>
                  <mat-checkbox class="checkbox-margin" [(ngModel)]="header_Unit" (change)="ChangeHeader(5, $event)">Unit #</mat-checkbox>
                  <mat-checkbox class="checkbox-margin" [(ngModel)]="header_Smu" (change)="ChangeHeader(6, $event)">SMU</mat-checkbox>
                  <mat-checkbox class="checkbox-margin" [(ngModel)]="header_WorkOrder" (change)="ChangeHeader(7, $event)">Work Order</mat-checkbox>
              </div>
          </div>
      </div>
      <div>
          <ng-container *ngFor="let fc of formQCategories">
              <div style="margin: 24px 0px;">
                  <div style="display: flex;">
                      <h3 title="fc.QCategoryName">
                          <b><u></u></b>
                      </h3>
                      <div class="category">
                        <div style="float: right; cursor: pointer;">
                            <i *ngIf="fc.Active" style="color: green;" class="material-icons sc-icon" title="Done" (click)="toggleFormSection(fc.QuestionCatId, false)">done</i>
                            <i *ngIf="!fc.Active" style="color: red;" class="material-icons sc-icon" title="Cancel" (click)="toggleFormSection(fc.QuestionCatId, true)">cancel</i>
                        </div>
                        <div>
                            <span style="font-size: larger;">
                                <b><u>{{ fc.QCategoryName }}</u></b>
                            </span>
                        </div>
                        <div class="leftmargin10">
                            <i class="material-icons sc-icon" style="margin-left: 10px; align-self: center; cursor: pointer;" title="Edit Category" (click)="OpenEditCategory(fc.FormId,fc.QuestionCatId,true,fc.QCategoryName)">edit</i>
                        </div>
                        <div class="leftmargin20">
                            <a class="button button--primary" title="Add Section" (click)="OpenAddSection(fc.QuestionCatId, fc.FormId)"> <span class="button__text">+ Section</span></a>
                        </div>
                        <div class="leftmargin10">
                          <ng-container *ngIf="fc.Order != 0">
                              <ng-container *ngIf="fc.Order == 1 && formQCategories.length != 2">
                                  <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_C(fc.Order, fc.FormId)" title="Change Order">arrow_drop_down</i>
                              </ng-container>
                              <ng-container *ngIf="fc.Order != 1 || formQCategories.length == 2">
                                  <ng-container *ngIf=" fc.Order == formQCategories.length - 1 && formQCategories.length != 2">
                                      <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_C(fc.Order, fc.FormId)" title="Change Order">arrow_drop_up</i>
                                  </ng-container>
                                  <ng-container *ngIf=" fc.Order != formQCategories.length - 1 && formQCategories.length != 2">
                                      <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_C(fc.Order, fc.FormId)" title="Change Order">arrow_drop_down</i>
                                      <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_C(fc.Order, fc.FormId)" title="Change Order">arrow_drop_up</i>
                                  </ng-container>
                              </ng-container>
                          </ng-container>
                        </div>
                      </div>
                  </div>
              </div>
              <ng-container *ngFor="let fs of formQSections">
                  <ng-container *ngIf="fs.ParentCatId && fs.ParentCatId == fc.QuestionCatId">
                      <div style="display: flex; margin-left: 5%;">
                          <div class="category">
                              <div style="float: right; cursor: pointer;">
                                  <i *ngIf="fs.Active" style="color: green;" class="material-icons sc-icon" title="Done" (click)="toggleFormSection(fs.QuestionCatId, false)">done</i>
                                  <i *ngIf="!fs.Active" style="color: red;" class="material-icons sc-icon" title="Cancel" (click)="toggleFormSection(fs.QuestionCatId, true)">cancel</i>
                              </div>
                              <div>
                                  <span style="font-size: larger;">
                                      <b><u>{{ fs.QCategoryName }}</u></b>
                                  </span>
                              </div>
                              <div class="leftmargin10">
                                  <i class="material-icons sc-icon" style="margin-left: 10px; align-self: center; cursor: pointer;" title="Edit Section" (click)=" OpenEditCategory(fc.FormId,fs.QuestionCatId,false,fs.QCategoryName)">
                                      edit
                                  </i>
                              </div>
                              <div class="leftmargin20">
                                  <a class="button button--primary" (click)="OpenAddQuestion(fs.QuestionCatId, fc.FormId)"> <span class="button__text" title="Add Question">+ Question</span></a>
                              </div>
                              <div class="leftmargin10">
                                <ng-container *ngIf="fc.Order>0">
                                  <ng-container *ngIf="fs.Order == 0 && fc.SectionCount > 1">
                                      <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_S(fs.Order, fc.FormId, fs.ParentCatId)" title="Change Order">arrow_drop_down</i>
                                  </ng-container>
                                  <ng-container *ngIf="fc.SectionCount != 1 && fs.Order != 0">
                                      <ng-container *ngIf="fs.Order == fc.SectionCount - 1">
                                          <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_S(fs.Order, fc.FormId, fs.ParentCatId)" title="Change Order">arrow_drop_up</i>
                                      </ng-container>
                                      <ng-container *ngIf="fs.Order != fc.SectionCount - 1">
                                          <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_S(fs.Order, fc.FormId, fs.ParentCatId)" title="Change Order">arrow_drop_down</i>
                                          <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_S(fs.Order, fc.FormId, fs.ParentCatId)" title="Change Order">arrow_drop_up</i>
                                      </ng-container>
                                  </ng-container>
                                </ng-container>
                              </div>
                          </div>
                      </div>
                      <div>
                          <table id="fs.QuestionCatId" style="width: 100%;" class="table table--full-width table--striped table--hover">
                              <thead>
                                  <tr>
                                      <th></th>
                                      <th style="text-align: inherit;">Question</th>
                                      <th style="text-align: inherit;">Type</th>
                                      <th style="text-align: inherit;">Has Image</th>
                                      <th *ngIf="fs.Order == 0 && fc.Order == 0" style="text-align: inherit;  display: none;">
                                          Include in Header
                                      </th>
                                      <th style="text-align: inherit;"></th>
                                      <th style="text-align: inherit;"></th>
                                      <th style="text-align: inherit;"></th>
                                  </tr>
                              </thead>
                              <tbody id="tbody-questions">
                                  <ng-container *ngIf="formQuestions != null">
                                      <ng-container *ngFor="let f of formQuestions">
                                          <tr *ngIf="f.QuestionCatId == fs.QuestionCatId">
                                              <td>
                                                  <div style="float: right; cursor: pointer;">
                                                      <i *ngIf="f.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleForm(f.QuestionId, false)">done</i>
                                                      <i *ngIf="!f.Active" style="color: red;" class="material-icons sc-icon" (click)="toggleForm(f.QuestionId, true)">cancel</i>
                                                  </div>
                                              </td>
                                              <td>
                                                  <div style="display: flex; flex-direction: row;">
                                                      <div class="sc-item2" title="{{ f.QDescription }}">
                                                          {{ f.QTitle }}
                                                      </div>
                                                  </div>
                                              </td>
                                              <td>
                                                  <div class="sc-item2" title="{{ f.QuestionTypeName }}">
                                                      {{ f.QuestionTypeName }}
                                                  </div>
                                              </td>
                                              <td style="text-align: center;">
                                                  <div class="ImageUpload" *ngIf="f.HasQuestionImage" style="text-align-last: start;">
                                                      <label>
                                                          <i style="color: black;" class="material-icons sc-icon">insert_photo</i>
                                                      </label>
                                                  </div>
                                                  <div class="ImageUpload" *ngIf="f.HasQuestionImage == false" style="text-align-last: start;">
                                                      <label>
                                                          <i style="color: black;" class="material-icons sc-icon">wallpaper</i>
                                                      </label>
                                                  </div>
                                              </td>
                                              <td *ngIf="fs.Order == 0 && fc.Order == 0" style="display: none;">
                                                  <div>
                                                      <mat-checkbox class="checkbox-margin" [(ngModel)]="f.isIncludeHeader" (change)="toggleIncludeFormHeader(f.QuestionId)"></mat-checkbox>
                                                  </div>
                                              </td>
                                              <td>
                                                  <div>
                                                      <i class="material-icons sc-icon iconlink" title="Edit Question" (click)="OpenEditQuestion(fc.FormId, f.QuestionId)">edit</i>
                                                  </div>
                                              </td>
                                              <ng-container *ngIf="f.Order == 0 && fs.QuestionCount != 1">
                                                  <td>
                                                      <span style="max-width: 30em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                                                          <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_Q(f.Order,fc.FormId,f.QuestionCatId)" title="Change Order">arrow_drop_down</i>
                                                      </span>
                                                  </td>
                                              </ng-container>
                                              <ng-container *ngIf="fs.QuestionCount != 1 && f.Order != 0">
                                                  <ng-container *ngIf="f.Order == fs.QuestionCount - 1">
                                                      <td>
                                                          <span id="cell_6" style="max-width: 30em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"> </span>
                                                      </td>
                                                      <td>
                                                          <span id="cell_6" style="max-width: 30em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                                                              <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_Q(f.Order,fc.FormId,f.QuestionCatId)" title="Change Order">arrow_drop_up</i>
                                                          </span>
                                                      </td>
                                                  </ng-container>
                                                  <ng-container *ngIf="f.Order != fs.QuestionCount - 1">
                                                      <td>
                                                          <span id="cell_6" style="max-width: 30em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                                                              <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_Q(f.Order,fc.FormId,f.QuestionCatId)" title="Change Order">arrow_drop_down</i>
                                                          </span>
                                                      </td>
                                                      <td>
                                                          <span style="max-width: 30em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                                                              <i style="font-size: 30px; cursor: pointer;" class="material-icons sc-icon" (click)=" OrderUP_Q(f.Order,fc.FormId,f.QuestionCatId)" title="Change Order">arrow_drop_up </i>
                                                          </span>
                                                      </td>
                                                  </ng-container>
                                              </ng-container>
                                          </tr>
                                      </ng-container>
                                  </ng-container>
                              </tbody>
                          </table>
                      </div>
                  </ng-container>
              </ng-container>
          </ng-container>
      </div>
      <div class="leftmargin20 maindiv">
          <a class="button button--primary" (click)="OpenAddCategory()"><span class="button__text" title="Add Category">+ Category</span></a>
      </div>
  </div>
</mat-card>